var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJuara2New(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1889_14939",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.0007,
    r: 12,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1889_14939)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.0007,
    r: 12,
    fill: "#F0F2F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21598 18.1539L8.19848 18.1764C8.09686 18.2933 7.97272 18.3885 7.83348 18.4564C7.71508 18.5108 7.58629 18.5389 7.45598 18.5389C7.39131 18.5384 7.32685 18.5317 7.26348 18.5189L7.70598 17.7514C7.85304 17.546 7.9519 17.31 7.99518 17.0612C8.03846 16.8123 8.02506 16.5568 7.95598 16.3139C7.84598 15.9989 7.64848 15.9614 7.58098 15.9489H7.55598C6.33208 15.6133 5.20368 14.996 4.26098 14.1464C4.11348 14.0139 3.97098 13.8789 3.83348 13.7364C3.69598 13.5939 3.54098 13.4039 3.40098 13.2364C3.08403 12.8563 2.7989 12.4507 2.54848 12.0239C1.82544 10.7906 1.39203 9.40914 1.28098 7.98386L1.25098 7.62886L1.42598 7.51636L5.12598 7.62886L5.11098 7.97136C5.11098 7.97136 5.08098 8.90636 5.61098 9.47136C5.73329 9.60331 5.88133 9.70881 6.04598 9.78136C6.27412 9.88023 6.51984 9.93209 6.76848 9.93386L6.94348 10.6489C6.64335 10.6304 6.34594 10.581 6.05598 10.5014C5.70528 10.3981 5.38854 10.203 5.13848 9.93636C4.74384 9.47642 4.50878 8.90105 4.46848 8.29636H1.96848C2.06234 9.06854 2.25735 9.82503 2.54848 10.5464C2.77515 11.1084 3.06093 11.6447 3.40098 12.1464C3.53848 12.3514 3.68598 12.5464 3.83848 12.7339C3.99098 12.9214 4.11598 13.0639 4.26598 13.2189C5.2068 14.212 6.40034 14.9302 7.71848 15.2964C7.77371 15.3072 7.82803 15.3222 7.88098 15.3414C8.04775 15.4037 8.19777 15.5038 8.31925 15.634C8.44072 15.7641 8.53031 15.9207 8.58098 16.0914C8.68554 16.4398 8.70698 16.8078 8.64359 17.166C8.58021 17.5242 8.43375 17.8625 8.21598 18.1539Z",
    fill: "url(#paint0_linear_1889_14939)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74992 8.07167L4.46742 8.28667H2.02742L1.91992 7.89917L4.74992 8.07167Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2152 18.1531L8.1977 18.1756C8.09608 18.2925 7.97194 18.3877 7.8327 18.4556C7.71429 18.51 7.58551 18.5382 7.4552 18.5381C7.39053 18.5376 7.32606 18.531 7.2627 18.5181L7.4377 18.4056L8.2152 18.1531Z",
    fill: "#777777"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37078 18.0639C8.2678 18.1808 8.14185 18.2752 8.00078 18.3414C7.88255 18.3966 7.75377 18.4256 7.62328 18.4264C7.55862 18.4259 7.49415 18.4192 7.43078 18.4064L7.87328 17.6289C8.02035 17.4235 8.1192 17.1875 8.16248 16.9387C8.20577 16.6898 8.19237 16.4343 8.12328 16.1914C8.02578 15.8764 7.82828 15.8389 7.75078 15.8264H7.72578C6.50189 15.4908 5.37348 14.8735 4.43078 14.0239C4.28328 13.8914 4.14078 13.7539 4.00328 13.6139C3.86578 13.4739 3.71578 13.2914 3.57578 13.1239C3.25883 12.7438 2.9737 12.3382 2.72328 11.9114C2.00056 10.6778 1.56639 9.29659 1.45328 7.87136L1.42578 7.51636H5.30078L5.28578 7.85886C5.28578 7.85886 5.25578 8.79386 5.78578 9.35886C5.90717 9.49074 6.05439 9.59626 6.21828 9.66886C6.4473 9.76773 6.69384 9.81959 6.94328 9.82136L6.92828 10.4764C6.68804 10.4725 6.44934 10.4372 6.21828 10.3714C5.86801 10.2674 5.55203 10.0715 5.30328 9.80386C4.90818 9.34421 4.67305 8.76867 4.63328 8.16386H2.13328C2.22573 8.93631 2.42078 9.69298 2.71328 10.4139C2.94238 10.983 3.23152 11.526 3.57578 12.0339C3.71328 12.2364 3.86078 12.4339 4.01328 12.6214C4.16578 12.8089 4.29078 12.9514 4.44078 13.1039C5.38146 14.0977 6.57497 14.8168 7.89328 15.1839C7.94797 15.1935 8.00157 15.2086 8.05328 15.2289C8.22081 15.2903 8.37162 15.3902 8.49361 15.5204C8.61561 15.6507 8.70539 15.8077 8.75578 15.9789C8.86171 16.332 8.88204 16.7053 8.81509 17.0679C8.74814 17.4304 8.59584 17.7718 8.37078 18.0639Z",
    fill: "url(#paint1_linear_1889_14939)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37098 18.0623C8.268 18.1792 8.14205 18.2737 8.00098 18.3398C8.67598 17.1298 8.30848 15.8398 8.04598 15.2273C8.21351 15.2888 8.36432 15.3886 8.48631 15.5189C8.6083 15.6491 8.69809 15.8061 8.74848 15.9773C8.85544 16.3299 8.877 16.7028 8.81136 17.0654C8.74572 17.4279 8.59477 17.7696 8.37098 18.0623Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22852 9.67651C6.45753 9.77538 6.70408 9.82724 6.95352 9.82901L6.93852 10.484C6.69828 10.4802 6.45958 10.4449 6.22852 10.379V9.67651Z",
    fill: "#777777"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6756 7.62808L22.6456 7.98308C22.5459 9.26201 22.187 10.5073 21.5906 11.6431C21.4731 11.8656 21.3406 12.0781 21.2181 12.2881C21.0956 12.4981 20.9481 12.6931 20.8031 12.8881C20.5671 13.1989 20.3116 13.4945 20.0381 13.7731C19.0267 14.8054 17.7594 15.5508 16.3656 15.9331H16.3406C16.2731 15.9331 16.0756 15.9831 15.9656 16.2981C15.8504 16.7155 15.894 17.1609 16.0881 17.5481C16.1256 17.6174 16.1699 17.6828 16.2206 17.7431L16.9231 18.4081L16.6731 18.5206C16.6098 18.5335 16.5453 18.5401 16.4806 18.5406C16.3807 18.5446 16.2809 18.5311 16.1856 18.5006C16.091 18.467 16.0017 18.4198 15.9206 18.3606C15.8511 18.3084 15.7867 18.2498 15.7281 18.1856C15.5042 17.8925 15.3528 17.5506 15.2863 17.1877C15.2198 16.8249 15.2402 16.4515 15.3456 16.0981C15.3984 15.9186 15.4944 15.7548 15.6252 15.621C15.7559 15.4872 15.9174 15.3875 16.0956 15.3306L16.1981 15.3056C17.7014 14.8857 19.0388 14.0128 20.0281 12.8056C20.3107 12.4632 20.5664 12.0997 20.7931 11.7181C20.9448 11.462 21.0833 11.1983 21.2081 10.9281C21.3493 10.6158 21.4736 10.2962 21.5806 9.97058C21.7559 9.4243 21.879 8.86261 21.9481 8.29308H19.4481C19.4078 8.89777 19.1728 9.47314 18.7781 9.93308C18.5275 10.202 18.2087 10.3981 17.8556 10.5006C17.6304 10.5655 17.3975 10.6 17.1631 10.6031L17.1481 9.94808C17.3911 9.94605 17.6314 9.8968 17.8556 9.80308C18.0274 9.72963 18.1816 9.62056 18.3081 9.48308C18.8406 8.91558 18.8081 7.98308 18.8081 7.98308L18.7931 7.64058L19.0431 7.52808L22.6756 7.62808Z",
    fill: "url(#paint2_linear_1889_14939)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2627 8.13448L21.9552 8.28448H19.4727V7.96948L22.2627 8.13448Z",
    fill: "#777777"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9342 7.51636L22.9042 7.87136C22.8033 9.1504 22.4435 10.3956 21.8467 11.5314C21.7317 11.7539 21.5967 11.9664 21.4742 12.1764C21.3517 12.3864 21.2042 12.5814 21.0592 12.7764C20.8239 13.0878 20.5683 13.3834 20.2942 13.6614C19.2837 14.6936 18.0172 15.439 16.6242 15.8214H16.5967C16.5317 15.8339 16.3342 15.8714 16.2242 16.1864C16.109 16.6038 16.1526 17.0492 16.3467 17.4364C16.3818 17.5079 16.4263 17.5743 16.4792 17.6339L16.9217 18.4114C16.8583 18.4241 16.7939 18.4308 16.7292 18.4314C16.6314 18.4318 16.5342 18.4158 16.4417 18.3839C16.3467 18.35 16.2574 18.302 16.1767 18.2414C16.1069 18.1914 16.0432 18.1335 15.9867 18.0689C15.7623 17.776 15.6105 17.4341 15.544 17.0712C15.4775 16.7083 15.4982 16.3347 15.6042 15.9814C15.6562 15.8015 15.7519 15.6373 15.8828 15.5034C16.0137 15.3695 16.1756 15.27 16.3542 15.2139C16.3869 15.2029 16.4203 15.1945 16.4542 15.1889C17.9577 14.7693 19.2951 13.8963 20.2842 12.6889C20.5675 12.348 20.8234 11.9852 21.0492 11.6039C21.2014 11.3472 21.3399 11.0826 21.4642 10.8114C21.6079 10.501 21.7323 10.1821 21.8367 9.85636C22.0135 9.30962 22.1366 8.74696 22.2042 8.17636H19.7042C19.6632 8.78088 19.4282 9.35605 19.0342 9.81636C18.7803 10.0879 18.457 10.285 18.0992 10.3864C17.8748 10.4511 17.6428 10.4855 17.4092 10.4889L17.3942 9.83386C17.6364 9.83157 17.8758 9.78233 18.0992 9.68886C18.2718 9.61545 18.4268 9.5064 18.5542 9.36886C19.0867 8.80136 19.0542 7.86886 19.0542 7.86886L19.0392 7.52636L22.9342 7.51636Z",
    fill: "url(#paint3_linear_1889_14939)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1767 18.2353C16.1069 18.1853 16.0432 18.1274 15.9867 18.0628C15.7623 17.7699 15.6105 17.428 15.544 17.0651C15.4775 16.7022 15.4982 16.3286 15.6042 15.9753C15.6562 15.7954 15.7519 15.6312 15.8828 15.4973C16.0137 15.3634 16.1756 15.2639 16.3542 15.2078C16.0767 15.7503 15.5967 16.9803 16.1767 18.2353Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1093 9.68433V10.3818C17.8849 10.4465 17.6528 10.481 17.4193 10.4843L17.4043 9.82933C17.6465 9.82704 17.8859 9.77779 18.1093 9.68433Z",
    fill: "#777777"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7223 7.07886C17.7223 7.35886 17.7223 7.65136 17.7023 7.95636C17.7023 8.08386 17.7023 8.20636 17.6848 8.34886C17.5695 10.4402 17.1855 12.508 16.5423 14.5014C15.6623 17.0539 14.2523 19.0939 12.1423 19.0939C8.36727 19.0939 6.81227 12.5514 6.58977 8.15386C6.58977 8.08886 6.58977 8.02136 6.58977 7.95636C6.58977 7.65136 6.57227 7.35886 6.57227 7.07886H17.7223Z",
    fill: "url(#paint4_linear_1889_14939)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8491 13.0011C13.8474 13.2324 13.834 13.4635 13.8091 13.6936C13.7916 13.6936 13.7091 13.8436 13.6766 13.8586H11.7766H11.0266C10.9691 13.7011 10.9116 13.5161 10.8691 13.3586C10.8691 13.3411 11.0091 13.2111 11.0041 13.1936C11.3105 12.982 11.6028 12.7507 11.8791 12.5011C12.0555 12.3497 12.2225 12.1878 12.3791 12.0161C12.5465 11.8113 12.643 11.5578 12.6541 11.2936C12.6611 11.1334 12.6135 10.9756 12.5191 10.8461C12.4763 10.7935 12.4221 10.7513 12.3606 10.7227C12.2991 10.6941 12.2319 10.6799 12.1641 10.6811C12.0626 10.6801 11.9617 10.6979 11.8666 10.7336L11.7516 11.2511C11.7341 11.2511 11.6341 11.4161 11.6166 11.4161C11.4141 11.4161 11.2091 11.3636 11.0241 11.3536C11.0416 11.0036 11.0641 10.6536 11.0866 10.3111C11.0866 10.2886 11.2216 10.1661 11.2216 10.1436C11.5854 10.0115 11.9696 9.94463 12.3566 9.94607C12.8941 9.94607 13.2141 10.0511 13.4541 10.2611C13.5682 10.3612 13.6594 10.4846 13.7215 10.6231C13.7836 10.7616 13.8152 10.9118 13.8141 11.0636C13.7939 11.4484 13.6328 11.8123 13.3616 12.0861C13.1228 12.3872 12.8435 12.6539 12.5316 12.8786C12.4466 12.9486 12.3741 13.0036 12.3016 13.0536C12.7266 13.0536 13.5091 13.0086 13.8491 13.0036V13.0011Z",
    fill: "#8B8B8B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8373 12.9993C13.4973 12.9993 12.7148 13.0418 12.2898 13.0493H12.2173V13.0268C12.3698 12.9218 12.4923 12.8393 12.6548 12.7068C12.9061 12.5204 13.1388 12.3103 13.3498 12.0793C13.621 11.8056 13.7821 11.4417 13.8023 11.0568C13.8035 10.9039 13.7715 10.7524 13.7085 10.613C13.6455 10.4736 13.5529 10.3495 13.4373 10.2493C13.1873 10.0393 12.8773 9.93435 12.3398 9.93435C11.9528 9.93291 11.5686 9.99977 11.2048 10.1318C11.2048 10.1543 11.0723 10.2768 11.0698 10.2993C11.0498 10.6193 11.1573 10.8493 11.1423 11.1743C11.2573 11.1743 11.3448 11.2818 11.4473 11.3493C11.4921 11.3814 11.5449 11.4005 11.5998 11.4043C11.6173 11.4043 11.7173 11.2393 11.7348 11.2393L11.8548 10.7168L11.8673 10.6568V10.6318C11.8705 10.6186 11.8786 10.607 11.8898 10.5993C12.0073 10.5287 12.1428 10.4939 12.2798 10.4993C12.3474 10.4982 12.4143 10.5122 12.4757 10.5403C12.5372 10.5685 12.5915 10.61 12.6348 10.6618C12.7285 10.7916 12.7752 10.9495 12.7673 11.1093C12.7495 11.444 12.6099 11.7605 12.3748 11.9993C12.2182 12.171 12.0512 12.333 11.8748 12.4843C11.5997 12.7382 11.3082 12.9737 11.0023 13.1893C11.0023 13.2068 10.8623 13.3368 10.8673 13.3543C10.9073 13.5043 11.1173 13.5568 11.1598 13.6968H11.9098C12.3123 13.6968 13.3098 13.8668 13.6748 13.8693C13.7073 13.8543 13.7898 13.7043 13.8073 13.7043C13.8335 13.4702 13.8477 13.2349 13.8498 12.9993H13.8373Z",
    fill: "#424242"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8808 10.6388V10.6638L11.8683 10.7238L11.7508 11.2513C11.7333 11.2513 11.6333 11.4163 11.6158 11.4163C11.5609 11.4124 11.5081 11.3934 11.4633 11.3613C11.4601 11.3155 11.4601 11.2695 11.4633 11.2238C11.4968 11.0678 11.567 10.922 11.6683 10.7988C11.6958 10.7663 11.8108 10.6113 11.8733 10.6363L11.8808 10.6388Z",
    fill: "#7E7E7E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8501 13.0004C13.8483 13.2318 13.835 13.4629 13.8101 13.6929C13.7926 13.6929 13.7101 13.8429 13.6776 13.8579L13.6426 13.8454L13.6801 13.1954L13.7076 13.1604L13.8401 12.9929L13.8501 13.0004Z",
    fill: "#7E7E7E"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7024 13.1701C13.3424 13.1701 12.4849 13.2151 12.0824 13.2226V13.1976C12.1574 13.1476 12.2224 13.1026 12.2899 13.0526C12.3574 13.0026 12.4349 12.9476 12.5199 12.8776C12.8318 12.653 13.1111 12.3863 13.3499 12.0851C13.546 11.8423 13.6575 11.5421 13.6674 11.2301C13.6683 11.078 13.6367 10.9275 13.5746 10.7886C13.5125 10.6498 13.4214 10.5258 13.3074 10.4251C13.0574 10.2151 12.7474 10.1101 12.2124 10.1101C11.8244 10.109 11.4392 10.1767 11.0749 10.3101C11.0524 10.6526 11.0299 11.0026 11.0124 11.3526C11.1974 11.3526 11.4024 11.4151 11.6049 11.4151L11.7499 10.8301C11.7536 10.8083 11.7641 10.7881 11.7799 10.7726C11.8093 10.7543 11.8403 10.7384 11.8724 10.7251C11.9675 10.6895 12.0683 10.6717 12.1699 10.6726C12.2377 10.6714 12.3049 10.6857 12.3664 10.7142C12.4279 10.7428 12.4821 10.785 12.5249 10.8376C12.6193 10.9672 12.6669 11.125 12.6599 11.2851C12.6442 11.5491 12.5433 11.8008 12.3724 12.0026C12.1863 12.2411 11.9778 12.4613 11.7499 12.6601C11.4746 12.9105 11.1841 13.1434 10.8799 13.3576C10.9224 13.5226 10.9799 13.7076 11.0374 13.8576H11.7874H13.6874C13.7123 13.6284 13.7256 13.3981 13.7274 13.1676L13.7024 13.1701Z",
    fill: "#63686E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5415 14.5014C15.9065 16.3414 15.0015 17.9189 13.7515 18.6539C13.2687 18.9425 12.7165 19.0946 12.154 19.0939C8.37898 19.0939 6.82398 12.5514 6.60148 8.15386C6.60148 8.08886 6.60148 8.02136 6.60148 7.95636C6.60148 7.65136 6.58398 7.35886 6.58398 7.07886H10.089L9.92148 7.71386C9.92148 7.71386 10.4415 20.1864 16.5415 14.5014Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8557 18.5814C9.46824 16.9714 7.94324 10.0289 7.50074 7.07886H6.88574C6.88574 7.35886 6.88574 7.65136 6.90574 7.95636C6.90574 8.02136 6.90574 8.08886 6.90574 8.15636C7.12574 12.4864 8.63824 18.9064 12.2932 19.0889L13.8557 18.5814Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7205 7.07886C17.7205 7.35886 17.7205 7.65136 17.7005 7.95636C17.7005 8.08386 17.7005 8.20636 17.683 8.34886C15.2149 8.07858 12.7335 7.94754 10.2505 7.95636C7.93055 7.95636 6.96305 8.05386 6.57805 8.15386C6.57805 8.08886 6.57805 8.02136 6.57805 7.95636C6.57805 7.65136 6.56055 7.35886 6.56055 7.07886H17.7205Z",
    fill: "#777777"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4169 6.75073L18.3244 7.06073L18.1569 7.62573H6.12187L5.85938 6.75073H18.4169Z",
    fill: "url(#paint5_linear_1889_14939)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0191 19.4739L13.9166 19.5614C13.7737 19.6858 13.6408 19.8212 13.5191 19.9664C13.4289 20.0616 13.3697 20.1818 13.3491 20.3114C13.3513 20.6714 13.3025 21.03 13.2041 21.3764C13.1708 21.495 13.129 21.6112 13.0791 21.7239L13.0591 21.7739C13.0366 21.8164 13.0166 21.8614 12.9941 21.9014C12.7766 22.3089 12.4741 22.5614 12.1416 22.5614C11.9553 22.555 11.7777 22.4813 11.6416 22.3539C11.4638 22.1926 11.3231 21.9947 11.2291 21.7739C11.0296 21.3125 10.9307 20.8139 10.9391 20.3114C10.9391 20.0139 10.2666 19.4739 10.2666 19.4739V19.4589L10.5166 18.6414H13.7516L13.8816 19.0564L13.9766 19.3564L14.0091 19.4589L14.0191 19.4739Z",
    fill: "#878C98"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0141 19.4589H10.2666L10.5241 18.6414H13.7566L13.8866 19.0564L13.9816 19.3564L14.0141 19.4589Z",
    fill: "url(#paint6_linear_1889_14939)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6367 22.3539C11.2217 21.9989 10.9342 21.2189 10.9342 20.3114C10.9342 20.0139 10.2617 19.4739 10.2617 19.4739L10.5242 18.6414H13.7517C13.7517 18.6414 10.4742 18.7889 11.2142 19.5664C11.2617 19.6989 11.7892 19.7314 11.7892 19.7314C11.7892 19.7314 11.2892 21.6314 11.9517 21.7739C12.2717 21.8389 12.0017 22.1014 11.6367 22.3539Z",
    fill: "#777777"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2775 22.5617H11L11.2225 21.7742H13.0575L13.1125 21.9767L13.25 22.4567L13.2775 22.5617Z",
    fill: "url(#paint7_linear_1889_14939)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8031 28.1593H10.4756L11.0006 22.5593H13.2781L13.2881 22.6668L13.8031 28.1593Z",
    fill: "#878C98"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0166 19.4729L13.9141 19.5604C13.2216 19.5604 12.2516 19.5179 11.9141 19.5129C12.1041 19.5055 12.2936 19.4871 12.4816 19.4579C12.9623 19.3716 13.4331 19.2368 13.8866 19.0554L13.9816 19.3554L14.0141 19.4579L14.0166 19.4729Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2879 22.6703L11.7354 22.5628L13.2354 22.4578L13.2704 22.5628L13.2879 22.6703Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4194 6.75073L18.3269 7.06073L9.04688 6.75073H18.4194Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.955 21.7742L11.7625 22.5617H11L11.2225 21.7742H11.955Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7631 22.5593L11.4856 28.1593H11.4281H10.4756L11.0006 22.5593H11.7631Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3175 7.62573H6.125L5.875 6.75073H8.105C7.85 6.91073 7.155 7.54823 11.3175 7.62573Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87437 7.62573H6.12187L5.85938 6.75073H6.48937L6.87437 7.62573Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8,
    d: "M10.3694 13.8195C10.3694 13.8195 9.18941 11.097 9.41941 8.46948H8.33691C8.33691 8.46948 8.61191 12.0495 10.3694 13.8195Z",
    fill: "url(#paint8_linear_1889_14939)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8,
    d: "M14.1289 15.1645C14.1346 15.1373 14.1346 15.1092 14.1289 15.082C14.1764 14.3095 14.1289 8.46948 14.1289 8.46948H17.2264C17.2264 8.46948 17.2814 14.672 14.1289 15.1645Z",
    fill: "url(#paint9_linear_1889_14939)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0234 15.2631C14.0709 14.4931 14.0234 8.65308 14.0234 8.65308H15.2509C15.2509 10.0131 15.1234 13.6406 14.0234 15.2631Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4741 6.75073H12.1416V7.62573H14.4741V6.75073Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6516 6.75073H15.0391V7.62573H15.6516V6.75073Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0599 7.51636H20.2949V8.17386H21.0599V7.51636Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0599 11.5984V12.7759C20.8246 13.0873 20.569 13.383 20.2949 13.6609V12.6834C20.5782 12.3425 20.834 11.9797 21.0599 11.5984Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8461 7.51636H21.4736V8.17386H21.8461V7.51636Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8461 9.85229V11.5323C21.7311 11.7548 21.5961 11.9673 21.4736 12.1773V10.8073C21.6173 10.4969 21.7417 10.178 21.8461 9.85229Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57863 7.51636H2.72363V8.17386H3.57863V7.51636Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57613 12.0315V13.1215C3.25918 12.7414 2.97405 12.3359 2.72363 11.909V10.4265C2.95052 10.99 3.23627 11.528 3.57613 12.0315Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4402 7.51636H4.0127V8.17386H4.4402V7.51636Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4402 13.1043V14.0193C4.2927 13.8868 4.1502 13.7493 4.0127 13.6093V12.6218C4.1477 12.7893 4.2902 12.9518 4.4402 13.1043Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9207 18.4054C16.8573 18.4181 16.7929 18.4248 16.7282 18.4254C16.6304 18.4259 16.5332 18.4098 16.4407 18.3779C16.3799 18.0657 16.3481 17.7485 16.3457 17.4304C16.3807 17.5019 16.4253 17.5684 16.4782 17.6279L16.9207 18.4054Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5142 28.1595H12.5117L12.7542 23.782L13.5142 28.1595Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2287 28.1595H12.0762V23.782L12.2287 28.1595Z",
    fill: "#E8E8E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3066 20.1406C12.6191 20.3006 13.2566 20.9956 12.6341 21.7056C12.5267 21.7358 12.4173 21.7584 12.3066 21.7731C12.5439 21.7661 12.7799 21.8096 12.9991 21.9006C13.0423 21.9202 13.0826 21.9454 13.1191 21.9756L13.0641 21.7731L13.0841 21.7231C13.0841 21.7006 13.1041 21.6756 13.1116 21.6531C13.1248 21.6254 13.1365 21.597 13.1466 21.5681C13.1691 21.5081 13.1891 21.4431 13.2091 21.3756C13.3076 21.0292 13.3564 20.6706 13.3541 20.3106C13.3747 20.1811 13.434 20.0608 13.5241 19.9656C13.1295 20.085 12.719 20.144 12.3066 20.1406Z",
    fill: "#777777"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1889_14939",
    x1: 8.08098,
    y1: 12.6314,
    x2: -1.93152,
    y2: 13.7289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717A80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878C98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1889_14939",
    x1: 6.48078,
    y1: 13.3264,
    x2: 0.275782,
    y2: 4.10386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#828A93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1889_14939",
    x1: 15.2456,
    y1: 13.0281,
    x2: 22.6756,
    y2: 13.0281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717A80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878C98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1889_14939",
    x1: 15.5042,
    y1: 12.9714,
    x2: 22.9342,
    y2: 12.9714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#828A93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1889_14939",
    x1: 6.56227,
    y1: 13.0864,
    x2: 17.7223,
    y2: 13.0864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#878C98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1889_14939",
    x1: 5.85938,
    y1: 7.18823,
    x2: 18.4194,
    y2: 7.18823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#878C98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1889_14939",
    x1: 10.2666,
    y1: 19.0489,
    x2: 14.0141,
    y2: 19.0489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#899199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#878C98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1889_14939",
    x1: 11.09,
    y1: 22.1817,
    x2: 14.46,
    y2: 22.1392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E969E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#878C98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1889_14939",
    x1: 8.33691,
    y1: 11.1445,
    x2: 10.3694,
    y2: 11.1445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1889_14939",
    x1: 14.1289,
    y1: 11.817,
    x2: 17.2264,
    y2: 11.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuara2New);
export default __webpack_public_path__ + "static/media/juara-2-new.85f0b22505638208556f6917449d856a.svg";
export { ForwardRef as ReactComponent };